// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"544":"2bbeaa89","980":"c7625e31"}[chunkId] + ".chunk.css";
};